import BirlExercise from 'models/birl/exercise'
import updateModelMember from 'braindamage/api/updateModelMember'
import { useQueryClient, useMutation } from '@tanstack/react-query'
import update from 'immutability-helper'

const WeightMapWeightInput = ({ weightMap, setWeightMap, index }) => {
  const onChange = useCallback((event) => {
    const updatedWeightMap = update(weightMap, {
      [index - 1]: { weight: { $set: parseFloat(event.target.value) } }
    })
    setWeightMap(updatedWeightMap)
  })

  return (
    <input
      type="number"
      inputMode="numeric"
      className="text-xs text-center"
      step="0.1"
      tabIndex={index}
      value={weightMap[index - 1]?.weight}
      onFocus={(e) => {
        const target = e.target
        setTimeout(() => target.select(), 0)
      }}
      onChange={onChange}
    />
  )
}

const shiftWeightMap = (weightMap, shiftable) => {
  let updatedWeightMap = weightMap

  Object.entries(updatedWeightMap).forEach(
    ([weightMapIndex, weightMapItem]) => {
      updatedWeightMap = update(updatedWeightMap, {
        [weightMapIndex]: {
          weight: {
            $set: shiftable.weights[parseInt(weightMapIndex) + shiftable.index]
          }
        }
      })
    }
  )

  updatedWeightMap.map((i) => {
    console.log('i.weight', i.weight)
  })

  return updatedWeightMap
}

export default ({ birlExercise }) => {
  const [isEditing, setIsEditing] = useState(birlExercise.isMissingWeightMap)
  // const [isEditing, setIsEditing] = useState(true)
  const [weightMap, setWeightMap] = useState(birlExercise.withZerosWeightMap())
  const [fullWeightMap, setFullWeightMap] = useState(weightMap)
  const [shiftable, setShiftable] = useState()

  const queryClient = useQueryClient()

  const updateBirlExercise = useMutation({
    mutationFn: async (params) => {
      return updateModelMember(
        `/api/birl/exercises/${birlExercise.id}`,
        BirlExercise,
        { ['birlExerciseAttributes']: params }
      )
    },
    onSuccess: async (data) => {
      queryClient.invalidateQueries({
        queryKey: ['birl_exercise', birlExercise.id]
      })
      queryClient.setQueryData(['birl_exercise', birlExercise.id], data)
      queryClient.refetchQueries(['birl_exercise', birlExercise.id])
    },
    onSettled: async (data) => {
      // console.log("onSettled", data);
    },
    onError: async (data) => {
      console.log('onError', data)
    }
  })

  const save = useCallback(() => {
    updateBirlExercise.mutate(
      { weightMap },
      {
        onSettled: () => {
          setIsEditing(false)
        }
      }
    )
  })

  const edit = useCallback(() => {
    setIsEditing(true)
  })

  const cancelEdit = useCallback(() => {
    setIsEditing(false)
  })

  const shiftLeft = useCallback(() => {
    setShiftable((currentShiftable) => {
      let newShiftable = {}

      if (!currentShiftable) {
        currentShiftable = {}
        currentShiftable.index = 0
        currentShiftable.weights = fullWeightMap.map((weightMapItem) => {
          return weightMapItem.weight
        })

        newShiftable = currentShiftable
      }

      newShiftable.index = currentShiftable.index + 1
      newShiftable.weights = currentShiftable.weights

      if (!currentShiftable.weights[newShiftable.index + 4]) {
        const diff =
          currentShiftable.weights[newShiftable.index + 3] -
          currentShiftable.weights[newShiftable.index + 2]

        currentShiftable.weights[newShiftable.index + 4] =
          currentShiftable.weights[newShiftable.index + 3] + diff
      }

      setWeightMap((currentWeightMap) => {
        return shiftWeightMap(currentWeightMap, newShiftable)
      })

      return newShiftable
    })
  })

  const shiftRight = useCallback(() => {
    setShiftable((currentShiftable) => {
      let newShiftable = {}

      if (!currentShiftable) {
        currentShiftable = {}
        currentShiftable.index = 0
        currentShiftable.weights = fullWeightMap.map((weightMapItem) => {
          return weightMapItem.weight
        })

        newShiftable = currentShiftable
      }

      newShiftable.weights = currentShiftable.weights
      newShiftable.index = currentShiftable.index

      if (newShiftable.index > 0) {
        newShiftable.index = newShiftable.index - 1
      } else if (currentShiftable.weights[newShiftable.index] != 0) {
        const diff =
          currentShiftable.weights[newShiftable.index + 1] -
          currentShiftable.weights[newShiftable.index]

        const newWeight = Math.max(
          currentShiftable.weights[newShiftable.index] - diff,
          0
        )

        newShiftable.weights.unshift(newWeight)
      }

      setWeightMap((currentWeightMap) => {
        return shiftWeightMap(currentWeightMap, newShiftable)
      })

      return newShiftable
    })
  })

  return (
    <>
      <div className="mb-d">
        {birlExercise.isMissingWeightMap ? (
          <div className="orange-transparent-box py-2 mb-d">
            <div className="text-center text-xl"> Set Initial Weights </div>
          </div>
        ) : null}
        <div className="frow flex-1">
          {isEditing && (
            <div className="btn btn-lg btn-secondary" onClick={shiftLeft}>
              <i className="ph ph-caret-double-left" />
            </div>
          )}

          {birlExercise.weightMap.map((weightMapItem) => {
            return (
              <div
                key={weightMapItem.index}
                className="flex-1 fcol items-center justify-center"
              >
                <div
                  className={clsx(
                    'rounded-top darkest-gray-transparent-box text-center',
                    { 'text-lg py-2': isEditing, 'text-sm': !isEditing }
                  )}
                  style={{ width: '100%' }}
                >
                  {weightMapItem.index}
                  <div
                    className="text-2xs text-center text-gray-400"
                    style={{ width: '100%' }}
                  >
                    {weightMapItem.range}
                  </div>
                </div>

                {isEditing ? (
                  <WeightMapWeightInput
                    weightMap={weightMap}
                    setWeightMap={setWeightMap}
                    index={weightMapItem.index}
                  />
                ) : (
                  <div
                    className={clsx(
                      'rounded-bottom gray-transparent-box text-center',
                      { 'text-3xl': isEditing, 'text-lg': !isEditing }
                    )}
                    style={{ width: '100%' }}
                  >
                    {isNaN(weightMapItem.weight)
                      ? '?'
                      : `${weightMapItem.weight}kg`}
                  </div>
                )}
              </div>
            )
          })}
          {isEditing && (
            <div className="btn btn-lg btn-secondary" onClick={shiftRight}>
              <i className="ph ph-caret-double-right" />
            </div>
          )}

          {isEditing ? null : (
            <div className="pl-d frow items-center">
              <div className="btn btn-icon btn-secondary" onClick={edit}>
                <i className="ph ph-pencil" />
              </div>
            </div>
          )}
        </div>
      </div>
      {isEditing ? (
        <div className="btn-group frow">
          <div className="btn btn-lg btn-primary flex-1" onClick={save}>
            Save
          </div>
        </div>
      ) : null}
      {isEditing && !birlExercise.isMissingWeightMap ? (
        <div className="text-gray-200 text-center mt-1" onClick={cancelEdit}>
          Cancel
        </div>
      ) : null}
    </>
  )
}
